export const highlightedTextTheme = {
  highlighted: 'palette.primary.50:0.5',
};
